import * as Sentry from '@sentry/react';

Sentry.init({
    dsn: 'https://f4616033897349a0ae5ebbc47a31ceb9@o4505276171223040.ingest.us.sentry.io/4505276174565376',
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    debug: process.env.REACT_APP_SENTRY_ENVIRONMENT === 'local',

    integrations: [
        // Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
        }),
    ],
    // there's a lot of noise in Sentry, so we only want to sample errors
    replaysSessionSampleRate: 0,
    // Replay sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#tracesSampleRate
    tracesSampleRate: 0.5,
    tracePropagationTargets: ['localhost', /^https:\/\/.*\.edgeboost\.io/],
});
